import { combineReducers } from 'redux';
import system from './system';
import user from './user';
import mt from './mt';
import sales from './sales';
import notice from './notice';

export default combineReducers({
    system,
    user,
    mt,
    sales,
    notice
});
